const keyAreas = [
  {
    label: "Leadership",
    value: "Lead and mentor high-performing security teams.",
  },
  {
    label: "Security Strategy",
    value: "Develop and implement strategies to reduce business risk.",
  },
  {
    label: "Risk Management",
    value: "Identify, assess and manage cyber risks effectively.",
  },
  {
    label: "Stakeholder Management",
    value: "Collaborate with stakeholders across",
  },
  //   {
  //     label: "Continuous growth",
  //     value: "Stay current with emerging threats and technologies.",
  //   },
];

const KeyAreaSection = () => {
  return (
    <div className="flex flex-col border rounded-xl bg-white p-6 gap-5">
      <span className="uppercase text-xs font-bold text-slate-600">
        key areas of focus
      </span>

      <div className="flex justify-between gap-4">
        {keyAreas?.map((keyArea) => {
          return (
            <div
              key={keyArea?.value}
              className="flex flex-col p-4 gap-2.5 bg-white border rounded-xl"
            >
              <div className="h-11 w-11 rounded-full border bg-gray-100"></div>
              <div className="flex flex-col gap-1">
                <span className="text-xs font-bold text-slate-800">
                  {keyArea?.label}
                </span>
                <span className="text-xss font-medium text-light-black">
                  {keyArea?.value}
                </span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default KeyAreaSection;
